module.exports = __webpack_public_path__ + "static/media/SharedBlueWithFiles.eff2249f.svg";